import { filter } from 'rxjs/operators';
import { DatePipe } from '@angular/common';
import { Component, Injectable, Input, NgZone, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal, ModalDismissReasons, NgbCalendar, NgbDate, NgbDateAdapter, NgbModalOptions, NgbActiveModal, NgbDateStruct, NgbDateParserFormatter, NgbDateNativeAdapter, NgbDatepicker, NgbDatepickerConfig } from '@ng-bootstrap/ng-bootstrap';
import { AppStateProvider } from 'src/app/services/app-state.provider';
import { DateService } from 'src/app/services/date.service';
import { facilityService } from 'src/app/services/facility.service';
import { SidenavService } from 'src/app/services/sidenav.service';
import { MeetingService } from 'src/app/services/meeting.service';
import { MeetingroomCancelPortalComponent } from 'src/app/modal/meetingroom-cancel-portal/meetingroom-cancel-portal.component';

@Injectable()
export class CustomAdapter extends NgbDateAdapter<string> {
  readonly DELIMITER = '-';

  fromModel(value: string | null): NgbDateStruct | null {
    if (value) {
      let date = value.split(this.DELIMITER);
      return {
        day: parseInt(date[0], 10),
        month: parseInt(date[1], 10),
        year: parseInt(date[2], 10),
      };
    }
    return null;
  }

  toModel(date: NgbDateStruct | null): string | null {
    return date
      ? date.day + this.DELIMITER + date.month + this.DELIMITER + date.year
      : null;
  }
}

/**
 * This Service handles how the date is rendered and parsed from keyboard i.e. in the bound input field.
 */
@Injectable()
export class CustomDateParserFormatter extends NgbDateParserFormatter {
  readonly DELIMITER = '/';

  parse(value: string): NgbDateStruct | null {
    if (value) {
      let date = value.split(this.DELIMITER);
      return {
        day: parseInt(date[0], 10),
        month: parseInt(date[1], 10),
        year: parseInt(date[2], 10),
      };
    }
    return null;
  }

  format(date: NgbDateStruct | null): string {
    return date
      ? date.day + this.DELIMITER + date.month + this.DELIMITER + date.year
      : '';
  }
}

@Component({
  standalone: false,
  selector: 'app-view-meeting-room-booking',
  templateUrl: './view-meeting-room-booking.component.html',
  styleUrls: ['./view-meeting-room-booking.component.scss']
})
export class ViewMeetingRoomBookingComponent implements OnInit {
  @Input() list;
  toDate: Date;
  selectAll: boolean = false;
  selectedToDate: any;
  tDate: any;
  formattedSelectedToDate: any;
  companyList: any;
  multiSelectionCompanyName: any = [];
  selectedCompanyName: any;
  selctionlength: number;
  selectedId: any;
  page: any = 1;
  tempHistoryList: any = [];
  pageSize: number = 10;
  tempDate: any;
  totalCount: any;
  BookingStatus: any = [
    { statusText: 'Confirmed', statusValue: true },
    { statusText: 'Cancelled', statusValue: false },
  ];
  openOptionDrawer: boolean = false;
  BookingStatusText: any;
  BookStatusValue: any;
  meetingRoomBookedDetails: any;
  meetingRoomId: any;
  meetingRoomName: string;
  tempTime: any;
  closeResult: string;
  disbursePoints: number = undefined;
  bookingId: any;
  multiSelectBookingId: any = [];
  singleBooking: boolean;
  tempMeetingRoomDetail: any[] = [];
  meetingNav: { index: string; name: string; link: string }[];
  fDate: any;
  fromDate: any;
  selectedFromDate: any;
  formattedSelectedFromDate: any;
  totalCountList: number = 0;
  pageNo = 1;

  constructor(
    private router: Router,
    public datepipe: DatePipe,
    private appStateSrv: AppStateProvider,
    private zone: NgZone,
    private dateAdapter: NgbDateAdapter<string>,
    private ngbCalendar: NgbCalendar,
    private ngbDatepickerConfig: NgbDatepickerConfig,
    private dateSrv: DateService,
    private apiSrvice: facilityService,
    private activatedRoute: ActivatedRoute,
    private modalService: NgbModal,
    private sideNavService: SidenavService,
    private meetingService: MeetingService,
  ) {
    ngbDatepickerConfig.outsideDays = 'visible';
  }

  ngOnInit(): void {
    this.meetingRoomName = localStorage.getItem('viewMeetingRoomName');
    this.activatedRoute.queryParams.subscribe((res) => {
      this.meetingRoomId = res.meetingRoomId;
    });

    const jsDate = new Date();
    this.BookingStatusText = this.BookingStatus[0].statusText;
    this.BookStatusValue = this.BookingStatus[0].statusValue;

    this.selectedToDate = this.datepipe.transform(jsDate, 'MM/dd/yyyy');
    this.selectedFromDate = this.datepipe.transform(jsDate, 'MM/dd/yyyy');

    this.formattedSelectedFromDate = this.dateSrv.convertDateToLocaleString(
      new Date().getDate(),
      new Date().getMonth(),
      new Date().getFullYear()
    );
    this.formattedSelectedToDate = this.dateSrv.convertDateToLocaleString(
      new Date().getDate(),
      new Date().getMonth(),
      new Date().getFullYear()
    );

    this.getMeetingRoomDetails();
  }

  getMeetingRoomDetails() {
    const body = {
      meetingRoomId: this.meetingRoomId,
      status: this.BookStatusValue,
      endDate: this.convertToDateFormat(this.selectedToDate),
      startDate: this.convertToDateFormat(this.selectedFromDate),
      parkTenantId: null,
      pageNo: this.pageNo,
      size: this.pageSize,
    };
    this.meetingService.bookedParkMeetingRooms(body).subscribe((res) => {
      console.log('detail', res);
      this.meetingRoomBookedDetails = res?.list;
      this.totalCountList = res?.list.length;
    });
  }

  compareDate(date) {
    return new Date(date) > new Date() ? true : false
  }

  setStatus(item) {
    this.BookingStatusText = item.statusText;
    this.BookStatusValue = item.statusValue;
    this.getMeetingRoomDetails();
  }

  onClickedOutside(e: Event) {
    console.log('Clicked outside:', e);
  }

  openPopover(popover, id) {
    this.singleBooking = false;
    this.disbursePoints = undefined

    console.log(id);
    if (id !== 0) {
      this.singleBooking = true;
      this.bookingId = id;
    }
    if (popover.isOpen()) {
      popover.close();
    } else {
      popover.open();
    }
  }

  public async updateSelectedFromDate(date: NgbDate) {
    const jsDate = new Date(date.year, date.month - 1, date.day);
    const delay = (ms) => new Promise((res) => setTimeout(res, ms));
    this.fromDate = jsDate;
    this.selectedFromDate = this.datepipe.transform(jsDate, 'MM/dd/yyyy');
    this.formattedSelectedFromDate = this.dateSrv.convertDateToLocaleString(
      date.day,
      date.month - 1,
      date.year
    );
    this.getMeetingRoomDetails();
  }

  public async updateSelectedToDate(date: NgbDate) {
    const jsDate = new Date(date.year, date.month - 1, date.day);
    const delay = (ms) => new Promise((res) => setTimeout(res, ms));
    this.toDate = jsDate;
    this.selectedToDate = this.datepipe.transform(jsDate, 'MM/dd/yyyy');
    this.formattedSelectedToDate = this.dateSrv.convertDateToLocaleString(
      date.day,
      date.month - 1,
      date.year
    );
    this.getMeetingRoomDetails();
  }

  // handlePageChange(event) {
  //   console.log(event);
  //   this.page = event;
  // }

  formatDate(date) {
    if (date == null) return;
    this.tempDate = date.split('T')[0].split('-');
    return this.dateSrv.convertDateToLocaleString(
      this.tempDate[2],
      this.tempDate[1] - 1,
      this.tempDate[0]
    );
  }

  formatTime(time) {
    if (time == null) return;
    // console.log(time);
    this.tempTime = time.split('T')[1].split(':');
    if (this.tempTime[0] == 12) {
      return this.tempTime[0] + ':' + this.tempTime[1] + 'PM'
    }
    else {
      return this.tempTime[0] > 12
        ? this.tempTime[0] - 12 + ':' + this.tempTime[1] + 'PM'
        : this.tempTime[0] + ':' + this.tempTime[1] + 'AM';
    }

  }

  open(content) {
    console.log('open modal', this.bookingId);
    this.modalService
      .open(content, {
        ariaLabelledBy: 'modal-basic-title',
        windowClass: 'modal-class',
        centered: true,
      })
      .result.then(
        (result) => {
          this.closeResult = `Closed with: ${result}`;
        },
        (reason) => {
          this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        }
      );
  }

  close(content) {
    // this.disbursePoints=0;

    this.modalService.dismissAll();
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  disburse() {
    const data = {
      bookingId: this.bookingId,
      amount: this.disbursePoints,
    };
    console.log(data);
    this.apiSrvice.disburseDeposit(data).subscribe((res) => {
      console.log(res);
      if (res?.isValid == true) {
        this.getMeetingRoomDetails()
      }
      this.disbursePoints = undefined;

    });
  }

  cancelBooking() {
    const data = {
      meetingBookingIds: this.singleBooking == true ? [this.bookingId] : this.multiSelectBookingId,
      userid: localStorage.getItem('userId'),
      isCLA: true,
    };

    const modalOptions: NgbModalOptions = {
      size: 'md',
    };

    const modalRef = this.modalService.open(MeetingroomCancelPortalComponent, modalOptions);
    modalRef.componentInstance.meetingRoomData = data;

    console.log("cancel", data)
    // this.meetingService.cancelBookedMeetingRoom(data).subscribe((res) => {
    //   console.log(res);
    //   if (res?.isValid == true) {
    //     this.getMeetingRoomDetails();
    //   }
    // });
  }

  toggleSelectAllSelection(show) {
    this.multiSelectBookingId = [];

    if (this.selectAll) {
      this.tempMeetingRoomDetail = this.meetingRoomBookedDetails.filter(el => new Date(el?.startDate) > new Date())
      console.log("select all", this.tempMeetingRoomDetail)
      this.tempMeetingRoomDetail.forEach((element) => {
        this.multiSelectBookingId.push(element.meetingRoomBookingId);
      });
    } else {
      this.multiSelectBookingId = [];
    }
    console.log('iddd', this.multiSelectBookingId);
    return this.multiSelectBookingId;
  }

  toggleSelection(show, id) {
    if (this.multiSelectBookingId.includes(id)) {
      this.multiSelectBookingId.splice(
        this.multiSelectBookingId.indexOf(id),
        1
      );
    } else {
      this.multiSelectBookingId.push(id);
    }

    this.selectAll =
      this.meetingRoomBookedDetails.length == this.multiSelectBookingId.length
        ? true
        : false;
    console.log('ifff', this.multiSelectBookingId);

    return this.multiSelectBookingId;
  }

  navigateToDetail() {
    this.router.navigate(['/meeting-room/details-meeting-room'], {
      queryParams: {
        id: this.meetingRoomId,
      },
    });
  }

  convertToDateFormat(dateString) {
    // Split the input date string into month, day, and year
    let [month, day, year] = dateString.split('/');

    // Add leading zeros if necessary
    month = month.padStart(2, '0');
    day = day.padStart(2, '0');

    // Return the date in YYYY-MM-DD format
    return `${year}-${month}-${day}`;
  }

  fetchPage(val) {
    return val % 10 == 0 ? Math.floor(val / 10) : Math.floor(val / 10) + 1;
  }

  handlePageChange($event) {
    this.pageNo = $event;
    this.page = event;
    this.getMeetingRoomDetails();
  }

  checkDurationType(duration) {
    if (duration == 'Daily') {
      return 'Days'
    } else if (duration == 'Hourly') {
      return 'Hours'
    } else {
      return 'Hours'
    }
  }
}
